module.exports = __webpack_public_path__ + "static/media/laravel.82639bcd.svg";